<template>
  <div class="mb-3">
    <label :for="inputID" class="form-label">{{ label }}</label>
    <input
      @change="update"
      :required="required"
      type="number"
      v-model="value"
      class="form-control"
      :max="max"
      :min="min"
      :id="inputID"
      :disabled="isDisabled"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "NumberInputComponent",
  components: {},

  data() {
    return {
      value: "",
    };
  },

  setup(props) {
    console.log(props);
  },

  props: {
    required: {
      type: Boolean,
    },
    max: {
      type: String,
    },
    min: {
      type: String,
    },
    label: {
      type: String,
    },
    inputID: {
      type: String,
    },
    isDisabled: {
      type: Boolean,
    },
  },

  methods: {
    update(event: Event) {
      console.log(event);
      this.$emit("onUpdate", this.inputID, this.value);
    },
  },
  emits: ["onUpdate"],
});
</script>

<style scoped>
input {
  min-width: 300px;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
</style>
